import { bool, func, number } from 'prop-types'
import { kuiperClassNames } from '@opallabs/kuiper'
import { ControlButton } from './ControlButton'
import './styles.scss'

const navigateToSlide = (backboneEditSlideNavigationCallback) => {
  if (backboneEditSlideNavigationCallback) backboneEditSlideNavigationCallback()
}

/* eslint-disable react/display-name */
const HoverableSlideThumbnailHOC = (SlideThumbnailComponent) => (props) => {
  const {
    backboneEditSlideNavigationCallback,
    deleteSlideBackboneCallback,
    destroySlide,
    isVisibleWhenPresenting,
    presentationId,
    slideId,
    toggleSlideVisibilityInUniverse,
    updateSlide,
  } = props

  const theme = props.theme === null ? {} : props.theme

  const shouldIgnoreEvent = (event) => {
    // tests call enzyme's `simulate('click')`, which doesn't create an event
    // object
    if (!event?.type) return false

    if (event.type !== 'keyup') return false
    return ![' ', 'Enter'].includes(event.key)
  }

  const deleteSlide = (event) => {
    if (shouldIgnoreEvent(event)) return

    event?.stopPropagation()

    destroySlide(presentationId, slideId)
    if (deleteSlideBackboneCallback) deleteSlideBackboneCallback()
  }

  const toggleVisibility = (event) => {
    if (shouldIgnoreEvent(event)) return

    event?.stopPropagation()

    toggleSlideVisibilityInUniverse()
    updateSlide(presentationId, slideId, {
      is_visible_when_presenting: !isVisibleWhenPresenting,
    })
  }

  const visibilityLabel = isVisibleWhenPresenting ? 'Hide' : 'Show'

  return (
    /* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */
    <div
      className={kuiperClassNames('hoverable-slide-thumbnail', {
        invisible: !isVisibleWhenPresenting,
      })}
      onClick={() => navigateToSlide(backboneEditSlideNavigationCallback)}
    >
      <ul aria-label="Controls" role="menubar" tabIndex={-1}>
        <li
          className={kuiperClassNames('visibility-button')}
          onClick={toggleVisibility}
          onKeyUpCapture={toggleVisibility}
          role="menuitem"
        >
          <ControlButton
            glyph={isVisibleWhenPresenting ? 'gem-eye' : 'gem-eye-hidden'}
            buttonName="Toggle Slide Visibility"
            tooltipContent={visibilityLabel}
          />
        </li>
        <li
          className={kuiperClassNames('delete-button')}
          onClick={deleteSlide}
          onKeyUpCapture={deleteSlide}
          role="menuitem"
        >
          <ControlButton
            glyph="gem-trash"
            buttonName="Delete Slide"
            tooltipContent="Delete"
          />
        </li>
      </ul>

      <SlideThumbnailComponent {...props} theme={theme} />
    </div>
  )
}

HoverableSlideThumbnailHOC.propTypes = {
  backboneEditSlideNavigationCallback: func,
  deleteSlideBackboneCallback: func,
  destroySlide: func,
  isVisibleWhenPresenting: bool,
  presentationId: number,
  slideId: number,
  toggleSlideVisibilityInUniverse: func.isRequired,
  updateSlide: func,
}

export default HoverableSlideThumbnailHOC
